import TableHeaderColumn from '@components/table/template/TableHeaderColumn'
import TextChartTitle from '@components/text/TextChartTitle'
import { IResponseGetProjectDataForDashboardRowData } from '@interfaces/api/IDashboard'
import { Progress, Table } from '@mantine/core'
import Money from '@utils/Money'
import _ from 'lodash'
import React from 'react'
import ChartFlexSection from './ChartFlexSection'
interface IAgencyRankingMultipleYearsChart {
    title: string
    data: IResponseGetProjectDataForDashboardRowData[]
}

const AgencyRankingMultipleYearsChart = ({
    data,
    title,
}: IAgencyRankingMultipleYearsChart) => {
    const preparedata = _(data)
        .groupBy('agency_name')
        .map((values, key) => ({
            agency_name: key,
            agency_type_name: values[0].agency_type_name,
            agency_budget_year: values[0].agency_budget_year,
            total_project_amount: _.uniqBy(values, 'project_id').length,
            total_project_budget: _.sumBy(
                values.map((e) => {
                    return {
                        ...e,
                        project_budget: Number(e.project_budget),
                    }
                }),
                'project_budget'
            ),
        }))
        .value()

    preparedata.sort(
        (a, b) =>
            Number(b.total_project_budget) - Number(a.total_project_budget)
    )
    return (
        <ChartFlexSection>
            <TextChartTitle>{title}</TextChartTitle>
            <Table pos={'relative'}>
                <thead>
                    <tr>
                        <TableHeaderColumn label={'อันดับ'} width={'5%'} />
                        <TableHeaderColumn label={'หน่วยงาน'} width={'40%'} />
                        <TableHeaderColumn label={'งบประมาณ'} width={'10%'} />
                        <TableHeaderColumn label={''} width={''} />
                    </tr>
                </thead>
                <tbody>
                    {preparedata.map((p, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{p.agency_name}</td>
                            <td>{Money(Number(p.total_project_budget))}</td>
                            <td>
                                <Progress
                                    w='100%'
                                    size='xl'
                                    sections={[
                                        {
                                            value:
                                                Number(p.total_project_budget) /
                                                (Number(
                                                    preparedata[0]
                                                        .total_project_budget
                                                ) /
                                                    100),
                                            color: 'blue',
                                        },
                                    ]}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ChartFlexSection>
    )
}

export default AgencyRankingMultipleYearsChart
